export const subtitles = {
    "1": {
        "startTime": 0.03,
        "endTime": 8.086,
        "transcript": "Icugg', cake mix-aanek pivailemta kayangunek avulegnek pitullruyaaqukut.",
        "translation": "So, before we had cake mix we had mixed eggs to it."
    },
    "2": {
        "startTime": 8.504,
        "endTime": 18.15,
        "transcript": "(I guess only Ina's in there.)",
        "translation": "Aanaq (granddaughter) aqumniartuq."
    },
    "3": {
        "startTime": 18.53,
        "endTime": 23.961,
        "transcript": "Cali emiqata'arqa, qaqicaaqnaurtuq.",
        "translation": "I'll add more water again so it can be ready."
    },
    "4": {
        "startTime": 24.135,
        "endTime": 33.21,
        "transcript": "Makut-qaa salmon berry-t atrit at'ngellruut wani-mi qaraliit salmon-aacetun?",
        "translation": "Are salmon berry named from salmon due to color?"
    },
    "5": {
        "startTime": 33.373,
        "endTime": 36.152,
        "transcript": "Ayuqngata.",
        "translation": "Or, because they are the same?"
    },
    "6": {
        "startTime": 36.276,
        "endTime": 38.697,
        "transcript": "Naamell'.",
        "translation": "I don't know."
    },
    "7": {
        "startTime": 38.817,
        "endTime": 46.847,
        "transcript": "Blueberry-t-wa tau͡gaam nallunrilkenka. Qucillgaat-qaa iingicetun?",
        "translation": "I do know of blueberry.  Like the eyes of cranes?"
    },
    "8": {
        "startTime": 47.857,
        "endTime": 56.878,
        "transcript": "Makut-wa atsat cameng atsaugat.",
        "translation": "I don't know why berries are berries."
    },
    "9": {
        "startTime": 57.638,
        "endTime": 64.2,
        "transcript": "Tuar-gguq curaq, curak.",
        "translation": "Like a blue berry, two blue berries."
    },
    "10": {
        "startTime": 64.78,
        "endTime": 73.301,
        "transcript": "Wall'u-qaa kiagmi salmon-aat nalliitni pilaata salmonberry-nek acillruit. Salmonberries... pilliit.",
        "translation": "Or, did they name them salmon berry because of the summer salmon fish.  Salmon berries ... maybe."
    },
    "11": {
        "startTime": 77.076,
        "endTime": 82.787,
        "transcript": "Maani pilalriit uksuaryartumi.",
        "translation": "They grow just at the beginning of fall."
    },
    "12": {
        "startTime": 97.544,
        "endTime": 105.576,
        "transcript": "Assaliurayuitukut makunek. Caqapqapiararqamta tau͡gaam.",
        "translation": "We don't make these fried bread regularly.  Only once in a while."
    },
    "13": {
        "startTime": 105.742,
        "endTime": 114.946,
        "transcript": "Ii-i, imumi assaliuratullruukut. Unuakumi-llu pegg'arraarluta Nalqiglimi.",
        "translation": "Yes, we usually made it in the morning after staying up all night at Nalqigliq"
    },
    "14": {
        "startTime": 115.086,
        "endTime": 123.065,
        "transcript": "Unuakuarmi uterrlua assaliqcaaralalrianga. Icugg', Aanagka aataka-ll' neqiurlukek.",
        "translation": "Early in the am I went home and made it.  You know, for my mom and dad's breakfast."
    },
    "15": {
        "startTime": 123.669,
        "endTime": 132.224,
        "transcript": "Umyuarteqaqlua unuk pegg'allruama akilirlukek, tamana pay back-aq umyuaqluku.",
        "translation": "I'd think... I was up all night I want to contribute, thinking of paying back."
    },
    "16": {
        "startTime": 132.474,
        "endTime": 141.793,
        "transcript": "Quyavkarnalukek uterrlua assalinaurtua. Carrie-llu cali yaa-i yaatemteńi assaliaqluni.",
        "translation": "I wanted them to be grateful and so I went home and made fried bread.  And, Carrie would do the same, make fried bread next door to us."
    },
    "17": {
        "startTime": 142.023,
        "endTime": 158.737,
        "transcript": "Pegg'arqavci calallruceci? Pegg'alallerput umyuaqaqamku tuar-tang caarkaituyuitellrulriakut nepliqaqsaunata-llu pinaurtukut.",
        "translation": "When you stayed up all night what did you do?  When I think of the nights we stayed up, we didn't do anything mischievious but we were pretty quiet."
    },
    "18": {
        "startTime": 158.827,
        "endTime": 164.01,
        "transcript": "Pelatekat elataitni. Nepliryaaqevkenata.",
        "translation": "Next to tents, we tried our best not to make any noise at all."
    },
    "19": {
        "startTime": 164.1,
        "endTime": 173.119,
        "transcript": "Tau͡gaam-am yaani napat iluatni aquivingqelallruukut icugg' carr'i... carrirluku.",
        "translation": "But, over yonder inside the trees we had a play ground on a clearing..clearing an area."
    },
    "20": {
        "startTime": 173.619,
        "endTime": 184.029,
        "transcript": "Tuani tua aquinaurtukut unugmi. Au͡gna-wa Maktaali-gguq una aturcetaalria imkunek.",
        "translation": "We played there at night.  And there was Maklaali who would play some music."
    },
    "21": {
        "startTime": 184.309,
        "endTime": 189.884,
        "transcript": "Tauna aturtekegciluni atii. Icugg' party-rpagluteng.",
        "translation": "That father of his had good singers. You know, they held a big party."
    },
    "22": {
        "startTime": 190.064,
        "endTime": 194.916,
        "transcript": "Nalqiglimeg'-am maligutellruukut three-aarluta nasaurlullrauluta-ll'.",
        "translation": "From Nalqigliq three of us went along as girls."
    },
    "23": {
        "startTime": 195.046,
        "endTime": 201.036,
        "transcript": "Sam Mill-aamun. Sam Miller taumun. Kalampiaq-wa angyaa.",
        "translation": "We went with Samil.  Sam Mili, that one.  His boat was a sail boat."
    },
    "24": {
        "startTime": 201.149,
        "endTime": 205.278,
        "transcript": "Icugg' kalampiat-ggun imum pektetullratni.",
        "translation": "You know they used sailboat to travel back then."
    },
    "25": {
        "startTime": 205.428,
        "endTime": 208.42,
        "transcript": "Tua-i-ll' tuani agnguaraqluteng.",
        "translation": "So, that's where we modern danced."
    },
    "26": {
        "startTime": 208.648,
        "endTime": 212.621,
        "transcript": "Tua-i-ll' wangkuta-ll' pinguangluta.",
        "translation": "And, we joined them."
    },
    "27": {
        "startTime": 212.901,
        "endTime": 225.952,
        "transcript": "Utercamta-ll' tua-i Nalqiglimi pegg'arqamta tauna aturcetaartekluku unugmi saatiss'aarluta, agnguaraqluta unugmi.",
        "translation": "When we went back to Nalqigliq, we did the same at night with him as our singer and danced (saatis style) at night."
    },
    "28": {
        "startTime": 226.102,
        "endTime": 230.3,
        "transcript": "Tuaten tuar pilallru...",
        "translation": "We did that seems like."
    },
    "29": {
        "startTime": 230.781,
        "endTime": 249.181,
        "transcript": "Waten wa tua-i piurararkaullrulriit. Una-ll' puqlirluku uqurkaqa.",
        "translation": "That's how you always had to do it.  I heat my oil, too I will use."
    },
    "30": {
        "startTime": 265.785,
        "endTime": 272.64,
        "transcript": "Waniwa-lluq tua-i video-lilua.",
        "translation": "So, now you're making a video of me.  Yes"
    },
    "31": {
        "startTime": 284.051,
        "endTime": 292.89,
        "transcript": "Tua-i imumi-kiq uqupianek assalitullruut. Qaillun-kiq... uqupiat-ggem tukniut.",
        "translation": "So, back in the day...they used rendered animal oil to make fried bread.  I wonder how...and rendered animal oil is strong."
    },
    "32": {
        "startTime": 293.342,
        "endTime": 302.95,
        "transcript": "Maa-i wesson oil-aamek kiingan uqilartua. Tua-i-ll' wesson oil-aunrilngurmek... wesson oil-aitaqama-ll' saalamek.",
        "translation": "Now, I only use wesson oil.  So, I don't use other than wesson oil...if I don't have wesson oil, I use shortening."
    },
    "33": {
        "startTime": 303.21,
        "endTime": 311.664,
        "transcript": "Imumek taugg uqunek... uqupianek. Akulmi-ll' pavani...",
        "translation": "But back then, rendered oil.  Tundra people, back there...(plane noise)"
    },
    "34": {
        "startTime": 328.138,
        "endTime": 347.009,
        "transcript": "Nalluyagutela'arqeka-tang TV-news-aryuitellrat. Ii-i. Imumi maantellemteńi unuaquaqan TV-iitgun news-arturalallruamta. Maa-i allakaungan kiingan radio-t-ggun pilaamta?",
        "translation": "I forget that that there is no TV news.  Yes...When we lived here we always had TV news every day.  It's different now with radio only."
    },
    "35": {
        "startTime": 368.48,
        "endTime": 378.802,
        "transcript": "Yuurqerciquten? Yaa, una-qaa cauga? Well-aq?",
        "translation": "Will you have tea?  Yes, what is in this?  Well water?"
    },
    "36": {
        "startTime": 387.773,
        "endTime": 396.452,
        "transcript": "Arnaq-wam akwaugaq jam-iqcaaralria call-allemteńi.",
        "translation": "Marie was making jam yesterday when we called her."
    },
    "37": {
        "startTime": 396.832,
        "endTime": 402.119,
        "transcript": "Cameg-kiq jam-ia. Blueberry-nek-wa pillill'.",
        "translation": "I wonder what kind of jam she's making.  Probably blue berries."
    },
    "38": {
        "startTime": 414.601,
        "endTime": 425.343,
        "transcript": "Tauna-llu-wam elluanriqerrluni iqugtek'lallra. Ava-i-llu ayakataan piluku court-akun.",
        "translation": "His fishing helper isn't working out.  And, he had a court summons."
    },
    "39": {
        "startTime": 425.733,
        "endTime": 436.495,
        "transcript": "Amta-ll' ava-i Raba-m pilua tuar-gguq nayulaqai. Akiani nengqerrami.",
        "translation": "But, Raba just told me he is staying with them.  She has a place across from it."
    },
    "40": {
        "startTime": 437.571,
        "endTime": 447.956,
        "transcript": "(Are you worried?) Kiimi-llu angutnguami maan' kiiryullill'.",
        "translation": "Penggartuten-qaa? (at camera guy). He is the only guy here, so maybe that's why he's hot."
    },
    "41": {
        "startTime": 467.793,
        "endTime": 474.233,
        "transcript": "(Qavarciigatnaqluni.) Oh, kiircenani. (Ii-i) fishcamp-amill",
        "translation": "It's hard to sleep.  Oh, too hot?  Yes (incomplete sentence due to editing)."
    },
    "42": {
        "startTime": 485.48,
        "endTime": 496.246,
        "transcript": "(Tumaglinek-qaa iqvalartut maani?) Naamelliin. Tuar-tang piksailnguut. Aren, naamell'.",
        "translation": "Do they pick cranberries here?  I do not know.  Maybe they haven't.  Or, I don't know."
    },
    "43": {
        "startTime": 498.766,
        "endTime": 506.385,
        "transcript": "Avani atem Manuquutarmiuni tumaglinek kenirluki pilituut.",
        "translation": "Over on the other side at Manokotak they make cranberry after cooking them."
    },
    "44": {
        "startTime": 506.873,
        "endTime": 517.63,
        "transcript": "Ripe-assiyaanrilengraata wall'u-q' ripe-arqata? Ripe-arqata. Atsiarnek piaqluki.",
        "translation": "Are they not quite rip or when they're ripe?  When they're ripe.  They call them cooked berry.  Yes"
    },
    "45": {
        "startTime": 518.802,
        "endTime": 529.032,
        "transcript": "Aanaka tamakumiunguqallermini pilitullruuq atsiaranek. II-i",
        "translation": "My mom when she lived there use to make cooked berry."
    },
    "46": {
        "startTime": 531.751,
        "endTime": 535.645,
        "transcript": "Ciin-kiq avani atsat...",
        "translation": "Why are berries over there...."
    },
    "47": {
        "startTime": 551.96,
        "endTime": 555.519,
        "transcript": "Tua-i-w' tuaten piss... piqataryuklua.",
        "translation": "I thought you were going to do that."
    },
    "48": {
        "startTime": 567.903,
        "endTime": 573.412,
        "transcript": "Una-llam elegciqaa. Atam elegqerngigtut.",
        "translation": "This might burn.  They burn easily."
    },
    "49": {
        "startTime": 574.062,
        "endTime": 581.699,
        "transcript": "You have to watch this. They really cook fast.",
        "translation": "Murilkelluku una.  Cukaluteng uulartut."
    },
    "50": {
        "startTime": 612.232,
        "endTime": 630.45,
        "transcript": "Tua-i qanernaurtukut imumi parent-aaput smart-allallruullinilriit. Waten-llam unuakumi icugg' fresh-anek assalianek avuurluteng yuurqeraqluteng.",
        "translation": "We use to say our parents were pretty elisngaq.  And just like this they ate fresh fried bread with their hot coffee/tea in the morning."
    },
    "51": {
        "startTime": 630.91,
        "endTime": 645.145,
        "transcript": "waniug tua-i taqlernek. Tuamta-ll' yuurqaqatarqameng... afternoon... tua-llu waten assaliqerluteng.",
        "translation": "Just finished right before.  And before they have tea in the afternoon they make another batch of  fried bread."
    },
    "52": {
        "startTime": 645.732,
        "endTime": 655.018,
        "transcript": "pinaurtua fresh-at assilliniata fresh-anek tang imkut neruratullrullinilriit.",
        "translation": "So, I saw fresh was best, and they ate fresh all the time."
    },
    "53": {
        "startTime": 701.388,
        "endTime": 724.952,
        "transcript": "naken picirkailnguut. Tau͡gaam qau͡gkut... keggna-ll' neighbor-aaqa kuvyaqcaaralaryaaqellria. Cikircetaaquma cikiryalliikiinga. Atam neighbor-aama kass'at kenkaatnga.",
        "translation": "Having no place to get them.  But those out there, and my next door neighbor does fish.  If I ask for some he may give me some.  My white caucausian neighbors care about me."
    },
    "54": {
        "startTime": 725.773,
        "endTime": 746.987,
        "transcript": "Kegg'um-llu call Shorty-m qagna elateka canegpilallrua. Tau͡gaam maa-i au͡g'um uingan Sue-am maantellermegni marayirluku shop-aliyaaqluku-llu. Tunellrua.",
        "translation": "And that one out there, Shorty planted grass seed on my lawn.  But, Sue's husband when he was here added mud and a shop. He sold it."
    },
    "55": {
        "startTime": 747.437,
        "endTime": 774.499,
        "transcript": "Tua-ll͡' qagna assiirulluku qagai nunaka qaugyam pile up-aarluni piciatun. Kiituan' tang Shorty-m canek piyuirutaa. Canegkanek, asmegtaqami-ll' elateka piuralallrua, ilakurlua. Taumek assik'laqka.",
        "translation": "It ruined it outside with sand piled up here and there, any which way.  And, Shorty is not even planting seed for grass anymore.  He use to cut the grass all the time, always including me.  That's why I like him."
    },
    "56": {
        "startTime": 778.722,
        "endTime": 806.15,
        "transcript": "Calirpanertuuq. Calirrlainalartuq. Atam tayim utreskuni flower-aaminek caliniartuq. Amta-llu iqap'agluni. Wiinga-gg' tease-alaqeka caaqama. Tua-i rest-amek nalluluni angu keggna. Calirrlainaq.",
        "translation": "He works very hard.  He works all the time.  I know he will work on his flowers when he gets home even though he's dirty.  I tease him sometimes.  That man, he really doesn't know what rest is.  Always working."
    },
    "57": {
        "startTime": 806.92,
        "endTime": 831.808,
        "transcript": "Ikegkut-qaa apartment-aat yungqelartut? Yaa. Yungqerturatuut. Erenrani calilaryugnarqut. Tua-i-ugg akitulalliata. Yaa akituut-gguq, $800 a month, tuaten-wa kina qanellrull'. Tua-lli-w' tua-i yungqerturatulriit.",
        "translation": "Do those apartments have people staying in them?  Yes.  They're always occupied. In the day I think they work.  They must be expensive.  Yes, they are expensive, $800 down is what someone said. And, there are people in them all the time."
    },
    "58": {
        "startTime": 844.623,
        "endTime": 852.646,
        "transcript": "Aanaaq, (ah) wall'uq tea bag-aqiluk.",
        "translation": "Ana, ah, lets just use tea bags."
    },
    "59": {
        "startTime": 866.378,
        "endTime": 904.496,
        "transcript": "Saarralirluk... yuurqaqitek. (I wanna try.) ... Puqlanirluteng atem aspiartut. Saskirlii? Saskirlii? Yaa",
        "translation": "Sugar them up, have some tea.  (Great-granddaughter says, 'naspaayugtua') They are excellent hot.  Can I get a tea cups.  Can I set cups?  yes"
    },
    "60": {
        "startTime": 905.489,
        "endTime": 934.87,
        "transcript": "Saskirluten, qallanguq. Calingnaqu'uryaaquq. Aspiaq. Akmani-wa akiitpialriit calilriit. Uksuq nutaan nallunriqenka. Akiitelalliniut calilriit. Maani-llu-wa cat...",
        "translation": "Get yourself a cup, it boiled.  (question unclear) She (Ana?) is looking for work.  Very good (fried bread just finished). Wages are very low for lower 48.  I found that out last winter.  They have lower wages.  Maybe here, things (incomplete due to editing)"
    }
};